var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.content},[_c('img',{class:_vm.$style.logo,attrs:{"src":require("@/assets/kno_logo_mark_white.svg")}}),_c('h1',[_vm._v("We'll be back soon!")]),_c('p',[_vm._v(" We are currently undergoing scheduled maintenance in order to improve the performance and reliability of our services ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }